export default __webpack_public_path__ + "static/pipeline-banner-bg-1e15806a24be6019590e1ec8bdc896ea.jpg";